import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = () => {
  return (
    <section className='error-message'>
      <h1>Wild ERROR Appeared!</h1>
      <p>Try again or come back later.</p>
    </section>
  );
}

export default ErrorMessage;